<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-01 14:50:38
 * @LastEditTime: 2019-10-22 15:08:34
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="content"   v-loading="fullscreenLoading" >
        <div class="pageTitle">

            
产品周转率计算公式：出货总数/平均库存
<br/>

平均库存=（期初库存+期末库存）/2
        </div>
            <el-form>
<!-- 
                    <el-form-item label="产品:" style="display:inline-block;margin-right:50px;">
                            <el-col :span='15' style='margin-right:20px;'>
                        <el-input v-model="product_sn" clearable></el-input>

                            </el-col>
                                    <el-col :span='2'>
                        <el-button @click="productDialog=!productDialog">选择</el-button>

                            </el-col>

                    </el-form-item> -->

                       <el-form-item label="经销商:" style="display:inline-block">
                            <el-col :span='15' style='margin-right:20px;'>
                        <el-input v-model="to_sn" clearable></el-input>

                            </el-col>
                                    <el-col :span='2'>
                        <el-button @click="selectDealerDialog=!selectDealerDialog">选择</el-button>

                            </el-col>

                    </el-form-item>
     
                <el-form-item style="margin-left:50px;float:right;margin-right:30%">
                    <el-button type="primary" @click="getData()">搜索</el-button>
                    <el-button @click="exportToExcel()">导出</el-button>
                </el-form-item>
            </el-form>
        <div style='position: relative;'>
                  <div class="countType">
                <el-button size="mini" @click="countFun('1')" :class="{'active':home_type=='1'}">月</el-button>
                <el-button size="mini" @click="countFun('2')" :class="{'active':home_type=='2'}">季</el-button>
                <el-button size="mini" @click="countFun('3')" :class="{'active':home_type=='3'}">年</el-button>
            </div>
        </div>
 
        <div id="main">
        </div>
        <el-table
                :data="tableList"
                border
                @row-click="chooseProduct"
                
                :row-style="tableRowStyle"
                stripe>
                 <el-table-column
                    prop="product_name"
                    label="产品名称"
                  >
            </el-table-column>
            <el-table-column
                    prop="turnover_data.start_stock"
                    label="期初库存"
                  >
                  <template slot-scope="scope">
                      {{scope.row.turnover_data.start_stock}}
                  </template>
            </el-table-column>
            <el-table-column
                    prop="end_stock"
                    label="期末库存"
                  >
                   <template slot-scope="scope">
                      {{scope.row.turnover_data.end_stock}}
                  </template>
            </el-table-column>
            <el-table-column
                    prop="average_stock"
                    label="平均库存">
                       <template slot-scope="scope">
                      {{scope.row.turnover_data.average_stock}}
                  </template>
            </el-table-column>
            <el-table-column
                    prop="out_stock"
                    label="出货总数">
                         <template slot-scope="scope">
                      {{scope.row.turnover_data.out_stock}}
                  </template>
            </el-table-column>
            <el-table-column
                    prop="turnover_percent"
                    label="产品周转率">
                    <template slot-scope='scope'>
                        {{scope.row.turnover_data.turnover_percent}}%
                    </template>
            </el-table-column>
        </el-table>
              <el-pagination
              style="margin: 20px 0"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNo"
              :page-sizes="[10, 15, 20, 25]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalSize"
            ></el-pagination>
        <selectDealer
      v-if="selectDealerDialog"
      v-on:handleClose="selectDealerDialog = false"
      @pushData="getSelectinfo"
    ></selectDealer>
    <product
      v-if="productDialog"
      v-on:handleClose="productDialog = false"
      @pushData="getproductinfo"
    ></product>
    </div>
</template>

<script>
import selectDealer from "@/components/logistics/common/selectDealer.vue";
import product from "./product.vue";
    import echarts from 'echarts'
    export default {
        name: "survey",
        data() {
            return {
                fullscreenLoading:false,
                selectDealerDialog:false,
                productDialog:false,
                tableData: [],
                charts: '',
                option: {
                    title: {      //标题组件
                        text: '出货产品周转率'
                    },
                    tooltip: {    //提示框组件
                        trigger: 'axis'
                    },
                    legend: {     //图例组件
                        data: ['出货数量'],
                        left:200
                    },
                    grid: {       //直角坐标系内绘图网格
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {     //工具栏
                        feature: {
                        }
                    },
                    xAxis: {       //直角坐标系 grid 中的 x 轴
                        type: 'category',
                        boundaryGap: false,
                        data: []
                    },
                    yAxis: {       //直角坐标系 grid 中的 y 轴
                        type: 'value'
                    },
                    series: [      //系列列表
                        {
                            name: '出货产品周转率',
                            type: 'line',
                            stack: '总量',
                            data: []
                        }
                    ]
                },
                home_type:'1',
                dealer_count:'',
                feeling_goods_num:'',
                stock_out_num:'',
                dataArr:[],
                numberArr:[],
                to_sn:"",
                product_sn:"",
                tableList:[],
                pageNo: 1,
                pageSize: 10,
                totalSize: 0,

            }
        },
        methods: {
            // 获取产品列表
            getProduct(){
 
                this.$get('logistics','/products').then(res => {
                    this.loading = false;
              
                    this.product_sn=res.data[0].product_sn
                    this.getData()
                }).catch(function (error) {
                    this.loading = false;
                    console.log(error);
                });
            },
            getTableList(){
                this.fullscreenLoading=true
                 this.$get('logistics','/turnovers.product', {
                    turnover_type:this.home_type,
                    to_sn:this.to_sn,
                    per_page:this.pageSize,
                    page:this.pageNo,
                    lang:""
                 }).then(res=>{
                this.fullscreenLoading=false
                     this.tableList=res.data
                    this.totalSize=res.meta.total
                     console.log(res)
                 }).catch(error=>{
                this.fullscreenLoading=false

                 })
            },
            chooseProduct(row,column,event){
                    this.fullscreenLoading=true

                this.product_sn=row.product_sn
                 this.getData()
            },
            //请求数据
            getData(){
                if(this.product_sn==''){
                     this.$message({
                        type: 'error',
                        message: "请选择产品"
                    });
                    return;
                }
                this.$get('logistics','/turnovers', {
                    lang:'',
                    to_sn:this.to_sn,
                    turnover_type:this.home_type,
                    product_sn:this.product_sn
                }).then(res => {
                    this.fullscreenLoading=false
                    this.tableData=res.data
                    for (var i = 0; i < res.data.length; i++) {
                        this.option.xAxis.data.push(res.data[i].name);
                        this.option.series[0].data.push(res.data[i].turnover_percent);
                    }
                    this.charts.setOption(this.option)
                }).catch(error => {
                    this.fullscreenLoading=false

                    this.$message({
                        type: 'error',
                        message: error.message
                    });
              
                });
            },
                     handleSizeChange(val){
            this.pageSize=val
            this.getTableList()
        },
        handleCurrentChange(val){
            this.pageNo=val

            this.getTableList()
        },
            exportToExcel() {
        //excel数据导出
            require.ensure([], () => {
                    const {
                        export_json_to_excel
                    } = require('@/plugins/excel/Export2Excel');
                    const tHeader = ['产品名称','期初库存', '期末库存', '平均库存', '出货总数','产品周转率'];
                    const filterVal = ['name','start_stock', 'end_stock', 'average_stock', 'out_stock','turnover_percent'];
                    const list = this.tableData;
                    const data = this.formatJson(filterVal, list);
                    export_json_to_excel(tHeader, data, '列表excel');
                })
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            onExport(){
                 let url = "",
                access_tokens = localStorage.getItem("access_tokens");
             
                 window.open(
                        this.$Base_Export +
                        "/turnovers.export?"+
                        "is_export=1"+
                        "&to_sn=" +
                        this.to_sn+
                        "&product_sn =" +
                        this.product_sn+
                           "&turnover_type=" +
                        this.home_type+
                        "&lang=" +
                        "" +
                        "&signature=" +
                        this.$md5(access_tokens)
                    );
            },
            countFun(type){
           
                this.home_type = type;
                this.option.xAxis.data = [];
                this.option.series[0].data = [];
                this.getData();
                this.getTableList()


            },
            //echart
            drawLine(id){
                this.charts = echarts.init(document.getElementById(id))
                this.charts.setOption(this.option)
            },
                //获取选择经销商门店
                getSelectinfo(val) {
                            this.to_sn = val.dealer_sn;
              
                },
                getproductinfo(val){
                    this.product_sn=val.product_sn
                    this.getData()
                },
            tableRowStyle({row}){
                if(row.product_sn==this.product_sn){
                    return `background-color: #f04635!important;color:#fff`
                }
            }
        },
        created(){

            // this.getData();
            this.getTableList()
            this.getProduct()
        },
        mounted() {
            this.$nextTick(function() {
                this.drawLine('main');
            })
        },
        
        components: {
            // , importData, deliverCodeDialog
            selectDealer,product
        }
    }
</script>

<style lang="scss" scoped>
    .content {
        // height: 100%;
        padding: 20px;
        position: relative;
        .countType{
            z-index: 99999;
            height: 40px;
            width: 200px;
            position: absolute;
            right:0;
            bottom:-60px;
        }
        .el-row {
            margin-bottom: 20px;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .el-col {
            border-radius: 4px;
        }
        .bg-color {
            background: #fff;
        }
        .grid-content {
            border-radius: 4px;
            border: 1px solid #ccc;
            min-height: 160px;
            span{
                padding: 15px;
                display: block;
                height: 20px;
                line-height: 20px;
                border-bottom: 1px solid #ccc;
            }
            p{
                padding: 36px 15px;
                font-size: 32px;
            }
        }
        .row-bg {
            padding: 10px 0;
            background-color: #f9fafc;
        }
        #main{
            width: 100%;
            height: 500px;
        }
        .block{
            box-sizing: border-box;
            border-radius: 4px;
            min-height: 70px;
            text-align: center;
            line-height: 70px;
            span{
                font-size: 24px;
            }
        }
    }
    .active{
        background-color: rgb(230, 243, 242);
        color: rgb(0, 139, 125)
    }
    .pageTitle{
        height: auto!important;
    }
    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td{
        background-color: initial;
    } 
</style>

